
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-758b1e04&scoped=true!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Privacy.vue")

var Component = require("!./../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./Privacy.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-758b1e04!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./Privacy.vue"),
  /* scopeId */
  "data-v-758b1e04",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/Privacy.vue
// module id = 452
// module chunks = 1